<template>
  <div class="sc-form-input relative" :class="[marginClasses, sizeClasses, errorClass]">
    <BaseLabel v-if="label && showLabel" :size="size" :for="id" :required="required">{{ label }}</BaseLabel>
    <div class="flex">
      <div class="flex items-center w-full">
        <div class="w-full">
          <input :id="id" :ref="id" :name="name" :aria-label="label" :value="value" class="sc-purchase-input"
            :type="type" :placeholder="placeholder" :readonly="readonly" :disabled="disabled"
            @keydown.delete="deleteEmpty()" @keydown.enter="$emit('enter')" @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event)" @blur="$emit('blur', $event)" autocomplete="off" />
          <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
            <div v-if="errorClass.length" class="input-error">
              <div class="has-tooltip">
                <img :src="`${scBaseUrl}/assets/images/Error.svg`" alt="Error" />
                <BaseToolTip :ref="`tooltip-error-${id}`" v-if="errorMessageText" class="tooltip-input" :tip="tip">{{
    errorMessageText
}}</BaseToolTip>
              </div>
            </div>
          </transition>
          <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
            <div v-if="loading" class="input-loader">
              <img :src="`${scBaseUrl}/assets/images/icons/preloadder.gif`" alt="Loading..." />
            </div>
          </transition>
          <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
            <div v-if="success" class="input-checked">
              <div class="has-tooltip">
                <img :src="`${scBaseUrl}/assets/images/Checked.svg`" alt="Checked" />
                <BaseToolTip class="tooltip-input" :ref="`tooltip-success-${id}`" :tip="tip" v-if="successMessage">{{
    successMessage
                  }}</BaseToolTip>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    successMessage: {
      type: String,
      default: "",
    },
    success: {
      type: Boolean,
      default: false,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      default: "w-full",
      type: String,
    },
    className: {
      default: "",
      type: String,
    },
    margin: {
      default: "base",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    validation: {
      default: "",
      type: String,
    },
    isVat: {
      default: false,
      type: Boolean,
    },
    tip: {
      default: "bottom-left",
      type: String,
    },
  },
  computed: {
    sizeClasses() {
      return this.className || this.size;
    },
    marginClasses() {
      return this.margin;
    },
    computedName() {
      if (this.name) {
        return this.name;
      } else if (this.id) {
        return this.id;
      } else {
        return "";
      }
    },
    errorClass() {
      if (this.error && (this.isVat || this.type == "email")) {
        return "has-error";
      } else if (this.error && !this.value.length) {
        return "has-error";
      }
      // else if (this.value.length && this.type == "email") {
      //   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //   return re.test(String(this.value).toLowerCase()) ? "" : "has-error";
      // }
      else if (this.validation.length && this.value.length) {
        switch (this.validation) {
          case "letters":
            const lettersOnly = /^[A-Za-z]+$/;
            return this.value.match(lettersOnly) ? "" : "has-error";
            break;
          case "alphanumeric":
            const alphaNumericOnly = /^[a-zA-Z0-9]+$/;
            return this.value.match(alphaNumericOnly) ? "" : "has-error";
            break;
          default:
            return "";
            break;
        }
      } else {
        return "";
      }
    },
    errorMessageText() {
      if (this.errorMessage.length) {
        return this.errorMessage;
      } else if (this.validation.length) {
        switch (this.validation) {
          case "letters":
            const lettersOnly = /^[A-Za-z]+$/;
            return this.value.match(lettersOnly) ? "" : "Please enter letters only.";
            break;
          case "email":
            const emailOnly = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return this.value.match(emailOnly) ? "" : "Please enter email.";
            break;
          default:
            return "";
            break;
        }
      }
      return "";
    },
  },
  methods: {
    deleteEmpty() {
      if (!this.value) {
        this.$emit("remove-empty");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseInput.vue?5e8a4fec